// extracted by mini-css-extract-plugin
export default {"metrics_pm":"MemorandumValues_metrics_pm__d1Mt0","column_metrics":"MemorandumValues_column_metrics__A67DP"};